






import * as Chart from 'chart.js';
const psCircle = 'circle';
const psCross = 'cross';
const psCrossRot = 'crossRot';
const psDash = 'dash';
const psLine = 'line';
const psRect = 'rect';
const psRectRounded = 'rectRounded';
const psRectRot = 'rectRot';
const psStar = 'star';
const psTriangle = 'triangle';

const pointStyles = [psCircle, psCross, psCrossRot, psDash, psLine, psRect, psRectRounded, psRectRot, psStar, psTriangle];

import { Vue, Prop, Watch, Component } from 'vue-property-decorator';

@Component({
  name: 'ui-chart',
})
export default class UiChartComponent extends Vue {
  @Prop() data!: any[][];
  @Prop() labels!: any[];
  @Prop() lineColor!: string;
  @Prop() fillColor!: string;
  @Prop() fill: boolean;
  @Prop({ default: false }) drawYBorder: boolean;
  @Prop({ default: false }) drawXBorder: boolean;
  @Prop({ default: 1 }) fixedStepSize: number;
  @Prop({ default: 'black' }) labelYColor: string;
  @Prop({ default: true }) displayYGrid: boolean;
  @Prop({ default: 'gray' }) gridYColor: string;
  @Prop({ default: true }) displayXGrid: boolean;
  @Prop({ default: 'gray' }) gridXColor: string;
  @Prop({ default: 'black' }) labelXColor: string;
  @Prop({ default: 12 }) labelXFontSize: number;
  @Prop({ default: 12 }) labelYFontSize: number;
  @Prop({ default: 'line', validator: (x) => pointStyles.includes(x) }) pointStyle: string;
  @Prop({ default: false, type: [Boolean, Number] }) curves: boolean | number;
  @Prop({ default: true }) beginAtZero: boolean;
  @Prop({ default: '' }) xaxeslabel: string;
  @Prop({ default: '' }) yaxeslabel: string;

  @Prop({ default: false }) loading: boolean;

  isLoading: boolean = this.loading;
  chart: any = null;
  shadowed = {
    beforeDatasetsDraw: function (chart, options) {
      chart.ctx.shadowColor = 'rgba(0, 0, 0, 0.25)';
      chart.ctx.shadowBlur = 10;
    },
    afterDatasetsDraw: function (chart, options) {
      chart.ctx.shadowColor = 'rgba(0, 0, 0, 0)';
      chart.ctx.shadowBlur = 0;
    },
  };
  @Watch('loading')
  onChangeLoading() {
    this.isLoading = this.loading;
  }
  mounted() {
    this.renderChart();
  }

  get options(): Object {
    return {
      title: {
        display: false,
      },
      tooltips: {
        enabled: true,
      },
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          boxWidth: 80,
          fontColor: 'black',
        },
      },
      scales: {
        yAxes: [
          {
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.yaxeslabel,
            },
            ticks: {
              beginAtZero: this.beginAtZero,
              fixedStepSize: this.fixedStepSize,
              fontColor: this.labelYColor,
              fontSize: this.labelXFontSize,
            },
            gridLines: {
              display: this.displayYGrid,
              color: this.gridYColor,
              drawBorder: this.drawYBorder,
            },
          },
        ],
        xAxes: [
          {
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.xaxeslabel,
            },
            ticks: {
              fontColor: this.labelXColor,
              fontSize: this.labelXFontSize,
            },
            gridLines: {
              display: this.displayXGrid,
              color: this.gridXColor,
              drawBorder: this.drawXBorder,
            },
          },
        ],
      },
      responsive: true,
    };
  }

  get chartData(): Object {
    let res = {
      labels: this.labels,
      datasets: [],
    };

    for (let item in this.data) {
      let x = {
        borderColor: this.lineColor,
        backgroundColor: this.fillColor,
        fill: this.fill,
        pointStyle: this.pointStyle,
        lineTension: this.curves,
        backgroundColor: 'transparent',
        pointBorderColor: 'white',
        pointRadius: 5,
        pointHoverRadius: 8,
        pointHitRadius: 30,
        pointBorderWidth: 2,
        pointStyle: 'circle',
        data: [],
      };
      for (let field in this.data[item]) {
        x[field] = this.data[item][field];
      }

      res.datasets.push(x);
    }
    return res;

    // return {
    //   labels: this.labels,
    //   datasets: [
    //     {
    //       borderColor: this.lineColor,
    //       backgroundColor: this.fillColor,
    //       fill: this.fill,
    //       data: this.data,
    //       pointStyle: this.pointStyle,
    //       lineTension: this.curves
    //     },

    //   ]
    // };
  }
  updateChart() {
    if (this.chart) {
      this.chart.data = this.chartData;

      this.chart.update();
    }
  }
  renderChart() {
    const ctx = (this.$refs.canvas as HTMLCanvasElement).getContext('2d');
    this.chart = new Chart(ctx, {
      type: 'line',
      options: this.options,
      data: this.chartData,
      plugins: [this.shadowed],
    });
  }

  @Watch('yaxeslabel')
  @Watch('xaxeslabel')
  onChangeOp() {
    if (this.chart) {
      this.chart.options = this.options;
      this.chart.update();
    }
  }

  @Watch('data')
  onDataChanged() {
    this.updateChart();
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-chart/src/ui-chart.vue